<n-data-table
    #dt
    [columnDefs]="tableColumnDefs"
    [config]="tableConfig"
    [data]="data"
    [loading]="loading"
    id="lun_group_detail_table_id">
    <ng-template [meta]="{field: 'HEALTHSTATUS'}"
        let-col
        let-data="rowData"
        nTemplate>
        <span>{{data[col.field] | keyValue: healthStatusE}}</span>
    </ng-template>
    <ng-template
        [meta]="{field: 'RUNNINGSTATUS'}"
        let-col
        let-data="rowData"
        nTemplate>
        <span>{{data[col.field] | keyValue: runningStatusE}}</span>
    </ng-template>
    <ng-template
        [meta]="{field: 'CAPACITY'}"
        let-col
        let-data="rowData"
        nTemplate>
        <n-percent-bar *ngIf="Number(data.SUBTYPE) === LUNSUBTYPE.CUSTOM
            || Number(data.SUBTYPE) === LUNSUBTYPE.COMPUTATIONALSTORAGE
            && !SWITCH.IS_DIRECT_MODE"
            [nTooltip]="capTips"
            [threshold]="data.ENABLEISCSITHINLUNTHRESHOLD === 'true' ? [
            { value: +data.ISCSITHINLUNTHRESHOLD, color: '#f83' }] : []"
            [value]="usageValue | fn :data"
            class="table-percent capacity">
        </n-percent-bar>
        <p [class]="SWITCH.IS_DIRECT_MODE ? 'direct-mode-capacity' : 'sub'" style="text-align: right;">
            {{data.CAPACITY | adaptUnit: 'Sector'}}
        </p>
        <ng-template #capTips>
            <n-kv *ngIf="data">
                <n-kv-item [key]="str.common.totalCapacityLab">
                    {{data.CAPACITY | adaptUnit: 'Sector'}}
                </n-kv-item>
                <n-kv-item [key]="str.common.alloccCapacityLab">
                    {{data.ALLOCCAPACITY | adaptUnit: 'Sector'}}
                </n-kv-item>
                <n-kv-item [key]="str.common.dataProtectionLab" *ngIf="!FeatureConfig.IsHideProtection">
                    {{data.REPLICATION_CAPACITY | adaptUnit: 'Sector'}}
                </n-kv-item>
                <n-kv-item
                    *ngIf="data.ENABLEISCSITHINLUNTHRESHOLD === 'true'"
                    [key]="str.common.alarmThresholdLab">
                    {{data.ISCSITHINLUNTHRESHOLD}}%
                </n-kv-item>
            </n-kv>
        </ng-template>
    </ng-template>
</n-data-table>
<ng-template #lunLinkTemp let-data="rowData">
    <app-mapping-lun-link [data]="data" (clickItem)="jumpToPath($event)" name="NAME" id="ID"></app-mapping-lun-link>
</ng-template>
